import { render, staticRenderFns } from "./OgranizersGroup.vue?vue&type=template&id=cf4d1376&"
import script from "./OgranizersGroup.vue?vue&type=script&lang=js&"
export * from "./OgranizersGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports